import { createRouter, createWebHashHistory, RouteRecordRaw } from 'vue-router'
import localCache from '@/utils/cache'
import { firstMenu } from '@/utils/map-menus'

const routes: RouteRecordRaw[] = [
  {
    path: '/',
    redirect: '/main'
  },
  // {
  //   path: '/desk-top',
  //   name: 'desk-top',
  //   component: () => import('@/views/desk-top/desk-top.vue')
  // },
  {
    path: '/login',
    name: 'login',
    component: () => import('@/views/login/login.vue')
  },
  {
    path: '/main/report/newFundsVerification/fill',
    name: 'newFundsVerificationFill',
    component: () =>
      import('@/views/main/report/newFundsVerification/fill/Fill.vue')
  },
  {
    path: '/main/report/newFundsVerification/detail',
    name: 'newFundsVerificationDetail',
    component: () =>
      import('@/views/main/report/newFundsVerification/detail/Detail.vue')
  },
  {
    path: '/main/report/custCommPlan/fill/',
    name: 'custCommPlanFill',
    component: () => import('@/views/main/report/custCommPlan/fill/Fill.vue')
  },
  {
    path: '/main/report/custCommPlan/detail',
    name: 'custCommPlanDetail',
    component: () =>
      import('@/views/main/report/custCommPlan/detail/Detail.vue')
  },
  {
    path: '/main/report/fundsVerification/fill',
    name: 'fundsVerificationFill',
    component: () =>
      import('@/views/main/report/fundsVerification/fill/Fill.vue')
  },
  {
    path: '/main/report/fundsVerification/detail',
    name: 'fundsVerificationDetail',
    component: () =>
      import('@/views/main/report/fundsVerification/detail/Detail.vue')
  },
  {
    path: '/main/helper/faq/FAQEditor',
    name: 'FAQEditor',
    component: () => import('@/views/main/helper/faq/FAQEditor.vue')
  },
  {
    path: '/main/helper/faq/FAQDetail',
    name: 'FAQDetail',
    component: () => import('@/views/main/helper/faq/FAQDetail.vue')
  },
  {
    path: '/main/report/customResourceApply/fill',
    name: 'customResourceApplyFill',
    component: () =>
      import('@/views/main/report/customResourceApply/fill/Fill.vue')
  },
  {
    path: '/main/report/customResourceApply/detail',
    name: 'customResourceApplyDetail',
    component: () =>
      import('@/views/main/report/customResourceApply/detail/Detail.vue')
  },
  {
    path: '/main',
    name: 'main',
    component: () => import('@/views/main/main.vue'),
    children: [
      require('./main/employee/UpdatePassword').default,
      {
        path: '/main/components/wangEditor',
        name: 'wangEditor',
        component: () => import('@/components/WangEditor.vue')
      },
      {
        path: '/main/report/ledger/recordLedger',
        name: 'recordLedger',
        component: () =>
          import('@/views/main/report/ledger/recordLedger/RecordLedger.vue')
      },
      {
        path: '/main/custom-detail',
        name: 'custom-detail',
        component: () => import('@/views/desk-top/custom-detail.vue')
      },
    ]
  },
  {
    path: '/:pathMatch(.*)*',
    name: 'not-found',
    component: () => import('@/views/not-found/not-found.vue')
  },
  {
    path: '/main/raffle/raffleManage/fill',
    name: 'raffleManageFill',
    component: () => import('@/views/main/raffle/raffleManage/fill/Fill.vue')
  },
  {
    path: '/main/raffle/raffleManage/detail',
    name: 'raffleManageDetail',
    component: () =>
      import('@/views/main/raffle/raffleManage/detail/Detail.vue')
  },
  {
    path: '/main/raffle/raffleRecord/record',
    name: 'raffleRecord',
    component: () => import('@/views/main/raffle/raffleRecord/RaffleRecord.vue')
  },
  {
    path: '/main/helper/databaseConfig/allUpdate',
    name: 'allUpdate',
    component: () => import('@/views/main/helper/databaseConfig/allUpdate/AllUpdate.vue')
  }
]

const router = createRouter({
  routes,
  history: createWebHashHistory()
})

router.beforeEach((to) => {
  if (to.path != '/login') {
    const token = localCache.getCache('token')
    if (!token) {
      return '/login'
    }
  }

  if (to.path === '/main') {
    return firstMenu.uri
  }
})

export default router
